import {
  DictionaryListParams,
  MaterialsAuthorsListParams,
  MaterialsHighlightsListParams,
  MaterialsInfoListParams,
  MaterialsListParams,
  MaterialsOpensearchSearchListParams,
  MaterialsPopularListParams,
  MaterialsSingleListParams,
  OrganizationsInfoListParams,
  OrganizationsPartnersInfoListParams,
  RubricsListParams,
  RubricTagsListParams,
  SravniMicroErrorsErrorModel,
  SravniNewsDataModelsDictionaryDto,
  SravniNewsDataModelsMaterial,
  SravniNewsDataModelsPlacementConfiguration,
  SravniNewsDataModelsTag,
  SravniNewsDomainRubricResultModel,
  SravniNewsServiceV1ModelsHighLigthResult,
  SravniNewsSharedEnumsMaterialType,
  SravniNewsSharedEnumsPlacementType,
  SravniNewsSharedModelsAuthorsAuthorReadModel,
  SravniNewsSharedModelsMaterialsHighLight,
  SravniNewsSharedModelsMaterialsMaterialInfoModel,
  SravniNewsSharedModelsMaterialsMaterialsInfoModel,
  SravniNewsSharedModelsPageModel1SravniNewsDataModelsMaterialSravniNewsDataVersion1000CultureNeutralPublicKeyTokenNull,
  SravniOrganizationsSharedOrganizationData,
} from '../__generated__/news/Api';
import { TYPE_VALUES } from '../constants/search';

import { RequiredBy } from './helpers';

export type TMaterialSingleQuery = MaterialsSingleListParams;
export type TMaterialQuery = { id: number };
export type TMaterialListQuery = MaterialsListParams;
export type TMaterialHighlightsListQuery = MaterialsHighlightsListParams;
export type TMaterialsPopularQuery = MaterialsPopularListParams;
export type TRubricsListQuery = RubricsListParams;
export type TDictionaryQuery = DictionaryListParams;
export type TMaterialList = SravniNewsSharedModelsPageModel1SravniNewsDataModelsMaterialSravniNewsDataVersion1000CultureNeutralPublicKeyTokenNull;
export type TMaterialHighlightsList = SravniNewsServiceV1ModelsHighLigthResult;
export type TRubricTagsQuery = RubricTagsListParams;
export type TTag = SravniNewsDataModelsTag;
export type TPlacementConfiguration = SravniNewsDataModelsPlacementConfiguration;
export type TErrorModel = SravniMicroErrorsErrorModel;
export type TMaterialsByDayQuery = MaterialsInfoListParams;
export type TMaterialsByDate = IMeterialsInfoModel;
export type TPartnersInfoQuery = OrganizationsPartnersInfoListParams;
export type TOrganizationData = SravniOrganizationsSharedOrganizationData;
export type TAuthor = SravniNewsSharedModelsAuthorsAuthorReadModel;
export type TOrganizationsInfoQuery = OrganizationsInfoListParams;
export type TAuthorsQuery = MaterialsAuthorsListParams;
export type TSearchQuery = MaterialsOpensearchSearchListParams;

export type TAuthorShort = Pick<
  TAuthor,
  'id' | 'displayName' | 'title' | 'rating' | 'isExpert' | 'vk' | 'ok' | 'telegram' | 'facebook' | 'instagram' | 'email'
>;

export type TMaterialShort = Pick<
  IMaterial,
  | 'id'
  | 'title'
  | 'picture'
  | 'miniPicture'
  | 'alias'
  | 'rubric'
  | 'type'
  | 'visits'
  | 'externalLink'
  | 'commentsCount'
  | 'createDate'
  | 'publishDate'
>;

export type TSearchTypes = 'news' | 'qna';

export interface IMaterial extends SravniNewsDataModelsMaterial {
  partnerMaterials?: string[];
  additionalReading?: string[];
  canCreateNewComments?: boolean;
}

export interface IHighlightedMaterial extends Omit<SravniNewsDataModelsMaterial, 'htmlBody' | 'htmlHead'> {}

export interface IMaterialHighlightsList {
  items?: IHighlightedMaterial[];
  hasMore?: boolean;
}

export interface IExtraMaterial
  extends Pick<
    SravniNewsDataModelsMaterial,
    'externalLink' | 'title' | 'visits' | 'publishDate' | 'miniPicture' | 'id' | 'alias' | 'type'
  > {}

export type THighLight = SravniNewsSharedModelsMaterialsHighLight;

export type TPartnerMaterial = IExtraMaterial;

export type TAdditionalReading = IExtraMaterial;

export type TPlacementConfigurationShort = Omit<TPlacementConfiguration, 'materials'> & {
  materials: Pick<
    TPlacementConfiguration['materials'][number],
    | 'id'
    | 'alias'
    | 'rubric'
    | 'type'
    | 'tags'
    | 'importance'
    | 'priorityOnMain'
    | 'priorityOnList'
    | 'priorityOnScroll'
    | 'priorityOnAdditionalReading'
    | 'isTargetPlacement'
    | 'placementProductTags'
    | 'placementTags'
    | 'externalLink'
  >[];
};

export type TPlacementConfigurationShortMap = {
  [key in SravniNewsSharedEnumsPlacementType]?: TPlacementConfigurationShort;
};

//TODO переписать типы параметров для прокси ручки
export interface IOneMoreArticleQuery extends RequiredBy<MaterialsListParams, 'Take'> {
  type: SravniNewsSharedEnumsMaterialType;
  placementId?: number[];
  excludeExternals?: boolean;
  excludeExternalsFromPlacements?: boolean;
  organizationId?: string;
  excludedAliases?: string[];
  excludePlacements?: boolean;
}

export interface IPlacementQuery
  extends Pick<
    IOneMoreArticleQuery,
    'Placement' | 'Rubrics' | 'Products' | 'Tags' | 'excludeExternalsFromPlacements' | 'excludedAliases' | 'ExcludedIds'
  > {}

export interface IMaterialsListQuery extends IOneMoreArticleQuery {}

export type TRubricType = MaterialsListParams['Rubrics'][number];

export interface IPartnersMaterialsQuery extends IOneMoreArticleQuery {}

export interface IAdditionalReadingQuery extends IOneMoreArticleQuery {}

export interface IHighLightsQuery extends IMaterialsListQuery {}

export interface IUpdateCacheParams {
  id: number;
}

export interface IReloadCacheQuery {
  ugc: 'true';
}

export interface IDictionaryDto extends Omit<SravniNewsDataModelsDictionaryDto, 'value'> {
  value?: TRubricType | string | null;
}

export interface IDictionaryResult {
  items?: IDictionaryDto[] | null;
}

export interface IMaterialInfoModel extends Omit<SravniNewsSharedModelsMaterialsMaterialInfoModel, 'rubricType'> {
  rubricType?: TRubricType;
}

export interface IMeterialsInfoModel extends Omit<SravniNewsSharedModelsMaterialsMaterialsInfoModel, 'items'> {
  items: IMaterialInfoModel[];
}

export interface IRubricResultModel extends Omit<SravniNewsDomainRubricResultModel, 'value'> {
  value?: TRubricType;
}

export interface IRubricDictionaryResult {
  items?: IRubricResultModel[];
}

export interface IPartnersInfoResult {
  [key: string]: TOrganizationData[];
}

export interface IRouterQuery {
  type?: string;
  alias?: string;
  rubric?: TRubricType;
  product?: 'strakhovanie' | string;
  tag?: string;
  rubricAlias?: TRubricType;
  year?: number;
  month?: number;
  day?: number;
  wl?: 'true' | 'wl';
  widget?: 'true' | 'widget';
  survey?: 'true' | 'survey';
  surveyId?: string;
  organizationId?: string;
  organizationType?: string;
  organizationAlias?: string;
  searchType?: TYPE_VALUES;
  text?: string;
  page?: string;
  sort?: string;
}

export interface IRouterAmpQuery extends IRouterQuery {
  fa?: string; //first article alias
  pl?: string; //placement page
  page?: string;
}

export type TXMLFeed = unknown;

export interface BottomMenuLink {
  name: string;
  link?: { as: string; href: string };
  url?: string;
  isActive: boolean;
  otherProps: {
    [p: string]: string | boolean | number;
  };
  isExternal: boolean;
}

export enum EXCLUDED_RUBRICS {
  PUTEVODITEL = 'putevoditel',
}

export interface IViews {
  [key: number]: number;
}
